'use strict';

module.exports = Backbone.View.extend({
    events: {
        'tap .ack_button': 'onAckClick',
    },

    initialize(options) {
        this.template = options.template;
        this.templateData = options.translations;
        this.page = options.page;

        this.render();
    },

    render() {
        this.$el.html(this.template(this.templateData));
    },

    onAckClick() {
        this.hide();
    },

    hide() {
        this.$el.addClass('odf-hidden');
        Odigeo.Session.set('FlightChangeFreeSystemAlertClosed', true);
    },
});
